import React, { useState, useEffect } from "react";
import Loader from "../../../components/common/loader";
import ImgManaged from "../../../components/common/img-managed";
import { Link } from "react-router";
import { Helmet } from "react-helmet";
import { CHAPEL_LIBRARY } from "../../../common/constants";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";

const Course = (props) => {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(true);
  const [course, setCourse] = useState(null);

  const { id } = useParams();

  useEffect(() => {
    props.getInfo(id).then((response) => {
      setCourse(response);
      setIsLoading(false);
    });
  }, [id]);

  function getParentDiv({ original }) {
    if (original) {
      return (
        <p>
          <i className="fa fa-course" aria-hidden="true"></i>
          <span>{t("english-title")}:</span>
          <Link to={`/course/${original.code}`} className="btn">
            {original.title}
          </Link>
        </p>
      );
    }
  }

  function getBookLink({ fileSuffix, format, name }, code, i) {
    const suffix = !!fileSuffix ? `-${fileSuffix}` : "";
    return (
      <>
        <a
          key={i}
          href={`${process.env.REACT_APP_API_URL}/${format}/courses/${code}${suffix}.${format}`}
          target="_blank"
          className="btn btn-primary"
          rel="noopener"
        >
          {name}
        </a>{" "}
      </>
    );
  }

  function getBooks({ courseBooks, code }) {
    const references = courseBooks.filter((r) => !r.isAnswerBook).reverse();
    const answers = courseBooks.filter((r) => r.isAnswerBook);

    const referencesList = references.map((book, i) =>
      getBookLink(book, code, i)
    );
    const answersList = answers.map((book, i) => getBookLink(book, code, i));

    const referenceSection = references.length > 0 ? referencesList : null;

    const answerSection = answers.length > 0 ? answersList : null;

    return (
      <div>
        {referenceSection}
        {answerSection}
      </div>
    );
  }

  if (isLoading) {
    return <Loader height={850} />;
  }

  var image =
    process.env.REACT_APP_API_URL +
    "/images/covers/courses/" +
    course.code +
    ".jpg";

  return (
    <div className="container">
      <Helmet>
        <title>
          {course.title} {t("bible-study")} - {CHAPEL_LIBRARY}
        </title>
        <meta name="description" content="" />
      </Helmet>
      <div
        className="row justify-content-center course-container"
        style={{ marginTop: "1em" }}
      >
        <div>
          <div
            className="col-sm-12"
            style={{ textAlign: "center", height: "400px" }}
          >
            <ImgManaged
              src={image}
              alt={course.title}
              type="Booklets"
              width={250}
            />
          </div>
        </div>
        <div className="col-sm-12 col-md-8">
          <div className="title">
            <h1>
              {course.title} - MZBI {t("bible-study")}
            </h1>
          </div>
          <div>
            <h4>
              <Link to={`/author/${course.author.code}`}>
                {course.author.name}
              </Link>
              {" " + course.author.date}
            </h4>
            <p
              className="text-justify"
              dangerouslySetInnerHTML={{ __html: course.description }}
            ></p>
            {getParentDiv(course)}
            <p>
              <span>{t("lessons")}:</span> {course.lessons}
            </p>
            <p>
              <span>{t("code")}:</span> {course.code}
            </p>
          </div>
          {getBooks(course)}
        </div>
      </div>
    </div>
  );
};

export default Course;
